var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 12.0001C5.33334 7.60031 5.33334 5.40041 6.89544 4.03359C8.45754 2.66675 10.9717 2.66675 16 2.66675C21.0283 2.66675 23.5425 2.66675 25.1045 4.03359C26.6667 5.40041 26.6667 7.60031 26.6667 12.0001V20.0001C26.6667 24.3998 26.6667 26.5997 25.1045 27.9666C23.5425 29.3334 21.0283 29.3334 16 29.3334C10.9717 29.3334 8.45754 29.3334 6.89544 27.9666C5.33334 26.5997 5.33334 24.3998 5.33334 20.0001V12.0001Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8383 18.9958C16.6135 19.2123 16.3129 19.3334 16.0001 19.3334C15.6873 19.3334 15.3868 19.2123 15.162 18.9958C13.1029 17.0006 10.3434 14.7718 11.6891 11.5359C12.4167 9.78629 14.1633 8.66675 16.0001 8.66675C17.8369 8.66675 19.5835 9.78629 20.3111 11.5359C21.6551 14.7677 18.9024 17.0074 16.8383 18.9958Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.3333H16.012",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 25.3333H17.3333",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.f78ecdc7a5ab0273d0942554fec66b01.svg";
export { ForwardRef as ReactComponent };